// extracted by mini-css-extract-plugin
export default {"shape":"Portfolio_shape__--etj","pTable":"Portfolio_pTable__WGcEa"};